<template>
    <!-- 右侧快捷键展示区 -->
    <div class="shortcut-panel">
        <div class="shortcut-title"><i class="el-icon-s-operation"></i> 快捷键</div>
        <div class="shortcut-list">
            <div @click="handleShortcutKey('SPLR')" v-if="keyMap.SPLR" class="shortcut-item"><span class="key">{{keyMap.SPLR.showName}}</span><span class="desc">{{keyMap.SPLR.groupName}}</span></div>
            <div @click="handleShortcutKey('XSYXZ')" v-if="keyMap.XSYXZ" class="shortcut-item"><span class="key">{{keyMap.XSYXZ.showName}}</span><span class="desc">{{keyMap.XSYXZ.groupName}}</span></div>
            <div @click="handleShortcutKey('HYLR')" v-if="keyMap.HYLR" class="shortcut-item"><span class="key">{{keyMap.HYLR.showName}}</span><span class="desc">{{keyMap.HYLR.groupName}}</span></div>
            <div @click="handleShortcutKey('SPXZ')" v-if="keyMap.SPXZ" class="shortcut-item"><span class="key">{{keyMap.SPXZ.showName}}</span><span class="desc">{{keyMap.SPXZ.groupName}}</span></div>
            <div @click="handleShortcutKey('XGKMM')" v-if="keyMap.XGKMM" class="shortcut-item"><span class="key">{{keyMap.XGKMM.showName}}</span><span class="desc">{{keyMap.XGKMM.groupName}}</span></div>
            <div @click="handleShortcutKey('GD')" v-if="keyMap.GD" class="shortcut-item"><span class="key">{{keyMap.GD.showName}}</span><span class="desc">{{keyMap.GD.groupName}}</span></div>
            <div @click="handleShortcutKey('QD')" v-if="keyMap.QD" class="shortcut-item"><span class="key">{{keyMap.QD.showName}}</span><span class="desc">{{keyMap.QD.groupName}}</span></div>
            <div @click="handleShortcutKey('BK')" v-if="keyMap.BK" class="shortcut-item"><span class="key">{{keyMap.BK.showName}}</span><span class="desc">{{keyMap.BK.groupName}}</span></div>
            <div @click="handleShortcutKey('TH')" v-if="keyMap.TH" class="shortcut-item"><span class="key">{{keyMap.TH.showName}}</span><span class="desc">{{keyMap.TH.groupName}}</span></div>
            <div @click="handleShortcutKey('LSTH')" v-if="keyMap.LSTH" class="shortcut-item"><span class="key">{{keyMap.LSTH.showName}}</span><span class="desc">{{keyMap.LSTH.groupName}}</span></div>
            <div @click="handleShortcutKey('JB')" v-if="keyMap.JB" class="shortcut-item"><span class="key">{{keyMap.JB.showName}}</span><span class="desc">{{keyMap.JB.groupName}}</span></div>
            <div @click="handleShortcutKey('FK')" v-if="keyMap.FK" class="shortcut-item"><span class="key">{{keyMap.FK.showName}}</span><span class="desc">{{keyMap.FK.groupName}}</span></div>
            <div @click="handleShortcutKey('CXFA')" v-if="keyMap.CXFA" class="shortcut-item"><span class="key">{{keyMap.CXFA.showName}}</span><span class="desc">{{keyMap.CXFA.groupName}}</span></div>
            <div @click="handleShortcutKey('TC')" v-if="keyMap.TC" class="shortcut-item"><span class="key">{{keyMap.TC.showName}}</span><span class="desc">{{keyMap.TC.groupName}}</span></div>
            <div @click="handleShortcutKey('SYFYXP')" v-if="keyMap.SYFYXP" class="shortcut-item"><span class="key">{{keyMap.SYFYXP.showName}}</span><span class="desc">{{keyMap.SYFYXP.groupName}}</span></div>
            <div @click="handleShortcutKey('TMWH')" v-if="keyMap.TMWH" class="shortcut-item"><span class="key">{{keyMap.TMWH.showName}}</span><span class="desc">{{keyMap.TMWH.groupName}}</span></div>
            <div @click="handleShortcutKey('HYCZ')" v-if="keyMap.HYCZ" class="shortcut-item"><span class="key">{{keyMap.HYCZ.showName}}</span><span class="desc">{{keyMap.HYCZ.groupName}}</span></div>
            <div @click="handleShortcutKey('QKHYXX')" v-if="keyMap.QKHYXX" class="shortcut-item"><span class="key">{{keyMap.QKHYXX.showName}}</span><span class="desc">{{keyMap.QKHYXX.groupName}}</span></div>
            <div @click="handleShortcutKey('QKGWC')" v-if="keyMap.QKGWC" class="shortcut-item"><span class="key">{{keyMap.QKGWC.showName}}</span><span class="desc">{{keyMap.QKGWC.groupName}}</span></div>
            <div @click="handleShortcutKey('CFSP')" v-if="keyMap.CFSP" class="shortcut-item"><span class="key">{{keyMap.CFSP.showName}}</span><span class="desc">{{keyMap.CFSP.groupName}}</span></div>
            <div @click="handleShortcutKey('ZYFS')" v-if="keyMap.ZYFS" class="shortcut-item"><span class="key">{{keyMap.ZYFS.showName}}</span><span class="desc">{{keyMap.ZYFS.groupName}}</span></div>
            <div @click="handleShortcutKey('JSQ')" v-if="keyMap.JSQ" class="shortcut-item"><span class="key">{{keyMap.JSQ.showName}}</span><span class="desc">{{keyMap.JSQ.groupName}}</span></div>
            <div @click="handleShortcutKey('DKQX')" v-if="keyMap.DKQX" class="shortcut-item"><span class="key">{{keyMap.DKQX.showName}}</span><span class="desc">{{keyMap.DKQX.groupName}}</span></div>
            <div @click="handleShortcutKey('ZZLY')" v-if="keyMap.ZZLY" class="shortcut-item"><span class="key">{{keyMap.ZZLY.showName}}</span><span class="desc">{{keyMap.ZZLY.groupName}}</span></div>
            <div @click="handleShortcutKey('KCFB')" v-if="keyMap.KCFB" class="shortcut-item"><span class="key">{{keyMap.KCFB.showName}}</span><span class="desc">{{keyMap.KCFB.groupName}}</span></div>
            
            <!-- 如果没有快捷键数据，显示加载提示 -->
            <div v-if="Object.keys(keyMap).length === 0" class="loading-tip">
                <i class="el-icon-loading"></i> 加载快捷键配置中...
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'shortcutPanel',
    mounted() {
        this.$http.cashdeskGetKeyMap().then(res => {
            console.log(res, 'res990');
            this.keyMap = res.result;
        })
    },
    data() {
        return {
         keyMap: {}
        }
    },
    methods: {
        handleShortcutKey(key) {
            this.$emit('shortcut-key', key);
        }
    }
}
</script>
<style scoped>
.shortcut-panel {
    width: 180px;
    min-width: 180px;
    max-width: 220px;
    background: #fff;
    border-left: 1px solid #dcdfe6;
    border-radius: 0;
    padding: 16px 10px 0 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin: 0;
    overflow-y: auto;
}

.shortcut-title {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 8px;
    color: #409EFF;
    display: flex;
    align-items: center;
}

.shortcut-title i {
    margin-right: 6px;
}

.shortcut-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.shortcut-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
}

.shortcut-item .key {
    min-width: 48px;
    padding: 0 5px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: #f2f6fc;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    margin-right: 10px;
    font-weight: bold;
}

.shortcut-item .desc {
    flex: 1;
    color: #606266;
}
.shortcut-item .desc:hover {
    color: #409EFF;
}
.loading-tip {
    text-align: center;
    color: #909399;
    padding: 20px;
    font-size: 14px;
}

.loading-tip i {
    margin-right: 5px;
}

@media screen and (max-width: 1366px) {
  .shortcut-panel {
    width: 180px;
    min-width: 160px;
  }
 
}

@media screen and (max-width: 1024px) {
  .shortcut-panel {
    display: none;
  }

}
</style>